import { BotId } from '@feedyou/schema'
import { AppKind } from './hosting'

// Parsing primarily with this "parse all function", and then reusing in other functions
// is somewhat of an antipattern, but is very helpful in clarifying how parsing apiUrl works
export function parseHostingApiUrl(apiUrl: string) {
  // Captures string between "//" and "."
  const hostingAppId = apiUrl?.match(/\/\/([^./]+)\./)?.[1]

  return {
    appKind: hostingAppId?.endsWith('-app') ? AppKind.WebApp : AppKind.FunctionApp,
    hostingAppId,
    hostingResourceGroupId: hostingAppId?.endsWith('-app')
      ? hostingAppId.slice(0, -4)
      : hostingAppId
  }
}

export function getHostingResourceGroupId(apiUrl: string): string
export function getHostingResourceGroupId(apiUrl: string | undefined): string | null
export function getHostingResourceGroupId(apiUrl?: string | undefined): string | null {
  return apiUrl // I <3 PRETTIER
    ? parseHostingApiUrl(apiUrl)?.hostingResourceGroupId ?? null
    : null
}

export function getHostingAppId(apiUrl: string): string
export function getHostingAppId(apiUrl: string | undefined): string | null
export function getHostingAppId(apiUrl?: string | undefined): string | null {
  return apiUrl // I <3 PRETTIER
    ? parseHostingApiUrl(apiUrl)?.hostingAppId ?? null
    : null
}

// Native = "natural" id the app should get launched with.
// This may not 1:1 map to an actual launched resource group id, because Azure may truncate it on launch if too long.
// If you have access to apiUrl for a launched bot, use it to determine the actual correct id
export function getNativeResourceGroupId(botId: BotId, environmentPrefix: string) {
  if (!environmentPrefix || environmentPrefix === 'false' || environmentPrefix === '0') {
    // Prefix non-existent, or wrongly parsed env var (BC)
    return 'feedbot-' + botId
  }

  if (environmentPrefix === 'designer' || botId.startsWith(`${environmentPrefix}-`)) {
    // Do not prefix if botId is already prefixed with current environment
    // also, ignore the "designer" instance gets no prefix
    return 'feedbot-' + botId
  }

  return `feedbot-${environmentPrefix}-${botId}`
}
